import { render, staticRenderFns } from "./AllocatedList.vue?vue&type=template&id=73c92b96"
import script from "./AllocatedList.vue?vue&type=script&lang=js"
export * from "./AllocatedList.vue?vue&type=script&lang=js"
import style0 from "./AllocatedList.vue?vue&type=style&index=0&id=73c92b96&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports